module.exports = __webpack_public_path__ + "static/img/95zhe.9036325.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newVcard/95zhe.png
// module id = CdBZ
// module chunks = 1